import { FC } from 'react';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { getDate } from 'utils/convertString';
import { entityTitleTranslations } from './translations';
import { IEntityTitleProps, EntityTitleTransFields } from './types';
import styles from './entityTitle.module.scss';

export const EntityTitle: FC<IEntityTitleProps> = ({ title, deletedDate }) => {
  const { t } = useMyTranslations<EntityTitleTransFields>([entityTitleTranslations.name]);

  return (
    <header className={styles.header}>
      <h2 className={styles.headerTitle}>{title}</h2>
      {deletedDate && <span className={styles.deletedLabel}>{`${t('deleted')} ${getDate(deletedDate)}`}</span>}
    </header>
  );
};
